// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__e8RIB","rotateHandler":"styles_rotateHandler__H0uKR"};
module.exports.__checksum = "347ee9218af4"
